import { TprmRequirementType } from '@evidentid/tprm-portal-lib/models/entity-details';

const FORM_ID_SEPARATOR = '::';

function isValidFormId(formId: string): boolean {
    return Boolean(formId && formId.includes(FORM_ID_SEPARATOR) && formId.split(FORM_ID_SEPARATOR).length >= 2);
}

export function buildRequirementFormId(ddrId: string, requirementType: TprmRequirementType): string {
    return `${ddrId}${FORM_ID_SEPARATOR}${requirementType}`;
}

export function getDdrIdFromFormId(formId: string): string | null {
    if (!isValidFormId(formId)) {
        return null;
    }
    return formId.split(FORM_ID_SEPARATOR)[0];
}

export function getRequirementTypeFromFormId(formId: string): string | null {
    if (!isValidFormId(formId)) {
        return null;
    }
    return formId.split(FORM_ID_SEPARATOR)[1];
}
